import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import {
  Toggle,
  TextField,
} from 'material-ui';
import TranslatableInput from './inputs/TranslatableInput';


const Button = t(({ id, onChange, prefix, values, translate }) => (
  <span>
    <TranslatableInput
      id={id}
      values={values && values.text}
      options={{ multiline: false }}
      name="text"
      label={translate('website.buttonText')}
      onChange={(val) => onChange(prefix ? `${prefix}.text` : 'text', id, val)}
    />

    <TextField
      className="block-field"
      floatingLabelText={translate('website.link')}
      fullWidth
      defaultValue={values && values.link ? values.link : ''}
      onChange={(e) => onChange(prefix ? `${prefix}.link` : 'link', id, e.target.value)}
    />

    <Toggle
      className="block-field toggle"
      name="internal"
      label={translate('website.internal')}
      labelPosition="right"
      defaultToggled={values && values.internal ? values.internal : false}
      onToggle={(e, val) => onChange(prefix ? `${prefix}.internal` : 'internal', id, val)}
    />
  </span>
));

export default Button;
